import axios from "axios";


const defaultConfigs = {
  timeout: 120000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    // 'Access-Control-Allow-Origin': "*"
  },
};

let instance = axios.create(defaultConfigs);

instance.interceptors.request.use(function (config) {
  return config;
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);
export default instance;